import React, { Suspense, lazy } from "react";
import { Routes as RouterRoutes, Route, Navigate } from "react-router-dom";

import ErrorBoundary from "components/ErrorBoundary";
import ScrollToTop from "components/ScrollToTop";

import UserAuthenticationGuard from "components/ui/UserAuthenticationGuard";
import LoadingMark from "components/ui/LoadingMark";
import AppLayout from "./AppLayout";

import Login from "pages/login";
import AuthCallback from "pages/login/components/AuthCallback";
import TryContractPage from "pages/try-contract";
import ContractDashboard from "pages/contract-dashboard";
import AccountManagement from "pages/account-management";
import UserConfiguration from "pages/user-configuration";
import NotificationsPage from "pages/notifications";
import { NotificationProvider } from "./context/NotificationContext";
import ContractGenerator from "pages/contract-generator";
import LicenseSelectionScreent from "pages/license-store";
import NotFound from "pages/NotFound";
import PurchaseHistory from "pages/purchases";
import LicenseOverview from "pages/license-overview/Index";
import CustomersPage from "pages/customers";
import CrmLeadsPage from "pages/crm-leads";
import CrmRespostasPage from "pages/crm-respostas";
import UserTemplatesPage from "pages/user-templates";
import UploadedDocumentsPage from "pages/uploaded-documents";
import CreateTemplatePage from "pages/create-template";
import EditTemplatePage from "pages/edit-template";
import PaymentReturnPage from "pages/payment-return";
import ModelLibraryPage from "pages/model-library";
import SystemModelsPage from "pages/system-models";

const WriteContractPage = lazy(() => import("pages/write-contract"));

const WriteContractFallback = () => (
  <div className="flex items-center justify-center min-h-[40vh] px-4">
    <LoadingMark message="Carregando editor…" />
  </div>
);

const Routes = () => {
  return (
    <ErrorBoundary>
      <ScrollToTop />

      <RouterRoutes>
        {/* ---------- Public routes ---------- */}
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/conhecer" element={<TryContractPage />} />

        {/* ---------- Protected app ---------- */}
        <Route
          path="/*"
          element={
            <UserAuthenticationGuard>
              <NotificationProvider>
                <AppLayout />
              </NotificationProvider>
            </UserAuthenticationGuard>
          }
        >
          <Route index element={<Navigate to="/contract-dashboard" replace />} />
          <Route path="contract-dashboard" element={<ContractDashboard />} />
          <Route path="account-management" element={<AccountManagement />} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="contract-generator" element={<ContractGenerator />} />
          <Route
            path="write-contract"
            element={
              <Suspense fallback={<WriteContractFallback />}>
                <WriteContractPage />
              </Suspense>
            }
          />
          <Route path="license-store" element={<LicenseSelectionScreent />} />
          <Route path="configurations" element={<UserConfiguration />} />
          <Route path="purchases" element={<PurchaseHistory />} />
          <Route path="my-license" element={<LicenseOverview />} />
          <Route path="customers" element={<CustomersPage />} />
          <Route path="crm/leads" element={<CrmLeadsPage />} />
          <Route path="crm/respostas" element={<CrmRespostasPage />} />
          <Route path="user-templates" element={<UserTemplatesPage />} />
          <Route path="model-library" element={<ModelLibraryPage />} />
          <Route path="system-models" element={<SystemModelsPage />} />
          <Route path="uploaded-documents" element={<UploadedDocumentsPage />} />
          <Route path="create-template" element={<CreateTemplatePage />} />
          <Route path="payment/success" element={<PaymentReturnPage />} />
          <Route path="payment/pending" element={<PaymentReturnPage />} />
          <Route path="payment/failure" element={<PaymentReturnPage />} />
          <Route path="edit-template" element={<EditTemplatePage />} />
        </Route>

        {/* ---------- Fallback ---------- */}
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
    </ErrorBoundary>
  );
};

export default Routes;